
const AddElementButton = ({ onClick }) => (
  <div 
    className="hvnly--builder---api_property__builder___add_element_btn" 
    onClick={onClick}
  >
    <i className="fas fa-plus"></i>
  </div>
);

export default AddElementButton;